<template>

  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Edit Data</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Edit Data
          </h3>
          <small>Change authors & company informations</small>
        </div>
      </div>
    </div>

    <div class="content">
      <companies-data></companies-data>
      <authors-data></authors-data>
    </div>

  </div>

</template>

<script>
import AuthorsData from '../../components/validateData/AuthorsData'
import CompaniesData from '../../components/validateData/CompaniesData'

export default {
  components: {AuthorsData, CompaniesData},
  name: 'EditData'
}
</script>



// WEBPACK FOOTER //
// src/pages/editData/EditData.vue